import styled from "styled-components";

const InputStyled = styled.div`
    position: relative;
    input {
        border: ${props => props.theme.lightGrayBorder};
        height: 5rem;
        padding-left: 2rem;
        padding-right: 2rem;
        border-radius: 0.5rem;
        display: block;
        width: 100%;
        background-color: transparent;
        &:disabled {
            background: #e6e5e5;
        }
    }

    .input__with__symbol {
        padding-left: 6rem;
    }

    .symbol {
        display: flex;
        justify-content: center;
        align-items: center;
        background: #f3f3f3;
        height: 5.4rem;
        width: 5rem;
        position: absolute;
        left: 0.1rem;
        padding-top: 0.5rem;
        border-top-left-radius: 0.5rem;
        border-bottom-left-radius: 0.5rem;
        z-index: -1;
    }
`;

export default InputStyled;
